<template>
  <span>
    <a v-for="(hotelData, index) in hotels" :key="index" 
      target="_blank"
      class="hidden-lg-and-up"
      :href=getLink(hotelData)
      >
      <span class="tlfs hidden" v-wow="{ 'animation-name': 'fadeInUp','animation-duration': '2s'}" :id=getId(index)>
          <span class="seMuestra"><span class="icon-whatsapp"></span> Hotel </span><span class="seEscondera" >{{hotelData.name}}</span>
      </span>
    </a>
      
    <span @click="showOrHidePhones()" id="whatsapp" style="font-size:36px" class="icon-whatsapp hidden-lg-and-up"></span>      
    <span @click="showOrHidePhones()" id="whatsapp" style="font-size:36px" class="icon-whatsapp hidden-md-and-down"></span>
  </span>
</template>

<script>
import { db } from '@/firebase.js'

export default {
  name: "Whatsapp",
  data () {
      return {        
        hotels: [],
        hotelsOnChildAdded: null,
        hotelsOnChildRemoved: null,
        hotelsRef: db.child("tambohotels")
      }
    },
  methods: {
    getId(index) {
      index++;
      return 'tlf'+ index;
    },
    getLink(hotelData) {
      let number = hotelData.phone;
      return 'https://wa.me/'+ number.replace(/\s/g, "") + '?text=¡Hola '+hotelData.name+'! Quisiera reservar...';
    },
    showOrHidePhones() {
      const tlf1 = document.getElementById('tlf1');
      const tlf2 = document.getElementById('tlf2');
      const tlf3 = document.getElementById('tlf3');

      if(!tlf1.classList.contains('visible')){
        tlf1.classList.remove('hidden');
        tlf1.classList.add('visible');
        tlf2.classList.remove('hidden');
        tlf2.classList.add('visible');
        tlf3.classList.remove('hidden');
        tlf3.classList.add('visible');
      }else{
        tlf1.classList.remove('visible');
        tlf1.classList.add('hidden');        
        tlf2.classList.remove('visible');
        tlf2.classList.add('hidden');        
        tlf3.classList.remove('visible');
        tlf3.classList.add('hidden');        
      }
    }, 
    async getHotels() {
      this.hotelsOnChildAdded = this.hotelsRef.on("child_added", snapshot => {
          const data = snapshot.val()
          const key = snapshot.key
          data.key = key
          this.hotels.push(data)
      })

      this.hotelsOnChildRemoved = this.hotelsRef.on("child_removed", snapshot => {
          const index = this.hotels.findIndex(e => e.key == snapshot.key)
          this.hotels.splice(index, 1)
      })    
    }        
  },
  created() {
      this.getHotels()      
  },
  beforeDestroy() {
      this.hotelsRef.off("child_added", this.hotelsOnChildAdded)
      this.hotelsRef.off("child_removed", this.hotelsOnChildRemoved)
  }
};
</script>

<style scoped>
#whatsapp {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 6%;
  right: 5%;
  background-color: #25d366;
  color: white;
  padding: 8px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 999;
  cursor: pointer;
}

.hidden {
  display: none;
}

.visible {
  display: block;
}

.tlfs{
  position:fixed;
  width: 175px;
  visibility:none;
  right:0;
  text-align:center; 
  font-size:12px;
  font-weight: bold;
  background-color: #25d366;
  color:white;
  padding: 8px;        
  z-index: 500;
  border-radius: 8px;
  cursor: pointer;
}

#tlf1{
  bottom:13%;
}
#tlf2{
  bottom:18%;
}
#tlf3{
  bottom:23%;
}
</style>



// WEBPACK FOOTER //
// Whatsapp.vue?18c11b24